"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminSections = void 0;
/**
 * if you add anything into this AdminSections object, also add the admin
 * permissions to those pages in aluminate -
 * api/src/models/PermissionsManager/permissionAreas.json;
 */
var AdminSections;
(function (AdminSections) {
    AdminSections["dashboard"] = "dashboard";
    AdminSections["insights"] = "insights";
    AdminSections["insights2"] = "insights2";
    AdminSections["insightsManage"] = "insightsManage";
    AdminSections["blocks"] = "blocks";
    AdminSections["notifications"] = "notifications";
    AdminSections["broadcasts"] = "broadcasts";
    AdminSections["notificationHistory"] = "notificationHistory";
    // 'apps' = 'apps',
    // 'reports' = 'reports',
    // 'exports' = 'exports',
    AdminSections["users"] = "users";
    AdminSections["userLists"] = "userLists";
    AdminSections["userListsPermissions"] = "userListsPermissions";
    // 'modules' = 'modules',
    // 'pageContent' = 'pageContent',
    AdminSections["settings"] = "settings";
    AdminSections["applications"] = "applications";
    AdminSections["entities"] = "entities";
    AdminSections["membershipRequests"] = "membershipRequests";
    AdminSections["layouts"] = "layouts";
    AdminSections["connections"] = "connections";
    AdminSections["emailTemplateBuilder"] = "emailTemplateBuilder";
    AdminSections["dataMappings"] = "dataMappings";
    AdminSections["tools"] = "tools";
    AdminSections["searchManagement"] = "searchManagement";
    AdminSections["reportAbuse"] = "reportAbuse";
})(AdminSections || (exports.AdminSections = AdminSections = {}));
